// import { $translate } from '@/utils/i18n';
export const tableConfig = {
    configuration: true,
    searchList: {
        searchLeftSpan: 12,
        searchRightSpan: 12,
        searchTxt: [
            {
                type: 'input',
                value: 'barcodeNo',
                span: 12,
                name: '条码',
                clearable: true
            },
            {
                type: 'select',
                value: 'successFlag',
                span: 12,
                name: '执行成功',
                clearable: true,
                options: [
                    {
                        value: 'Y',
                        label: '是'
                    },
                    {
                        value: 'N',
                        label: '否'
                    }
                ]
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: false,
        clickState: true,
        leftOperation: false,
        height: 400,
        rowKey: 'id',
        columns: [
            {
                label: '托盘码',
                align: 'center',
                prop: 'palletBarcodeNo',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '箱码',
                align: 'center',
                prop: 'cartonBarcodeNo',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '条码号',
                align: 'center',
                prop: 'barcodeNo',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '产品编码',
                align: 'center',
                prop: 'itemCode',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '产品名称',
                align: 'center',
                prop: 'itemName',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '扫码人',
                align: 'center',
                prop: 'scanBy',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '扫码日期',
                align: 'center',
                prop: 'scanDate',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '创建日期',
                align: 'center',
                prop: 'creationDate',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '是否执行',
                align: 'center',
                prop: 'processFlag',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '执行日期',
                align: 'center',
                prop: 'processDate',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '执行结果',
                align: 'center',
                prop: 'processDesc',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '是否执行成功',
                align: 'center',
                prop: 'successFlag',
                filter: true,
                require: true,
                sort: false,
                width: 120
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
